import React from 'react';
import {Slider as MUISlider, SliderProps} from '@mui/material';

import './slider.scss';

export interface Props extends SliderProps {
  error?: string;
  cy?: string;
  testid?: string;
}

const Slider = ({min = 0, max = 100, step = 1, error, cy, testid, ...remainingProps}: Props) => (
  <div className="shared-slider-wrapper" data-cy={cy} data-testid={testid}>
    <MUISlider step={step} min={min} max={max} {...remainingProps} />
    {error && (
      <p className="shared-error-text" role="alert">
        {error}
      </p>
    )}
  </div>
);

export default Slider;
